<template>
  <main>
    <wl-banner bgUrl='/static/img/product/labManagePlatform/banner.png' :bannerData='bannerData'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/labManagePlatform/bg1.png'">
      <section class="container">
        <wl-title title='科研实验室面临的常见问题' :isNeedDesc=false></wl-title>
        <section v-for="(item,index) in page1Data" :key="index" class="box" :class="'box'+index">
          <h3>{{item.title}}</h3>
          <p>{{item.desc}}</p>
        </section>
      </section>
    </section>
    <section class="page2">
      <article class="container">
        <wl-title title='解决方案' desc='面向高校、科研院所、医院等科研单位'></wl-title>
        <section class="flexWrap">
          <a class="box flex p-r" v-for="(item,idx) in page2Data" :key="item.key" :href="item.path">
            <section class="_icon " :style="`background-position: -${32*idx}px 0px;`"></section>
            <section class="sec">
              <h3>{{item.title}}</h3>
              <p>{{item.desc}}</p>
              <p>{{item.desc1}}</p>
            </section>
            <section class="_icon rightIcon" :style="`background-position: -${66*idx}px -32px;`"></section>
          </a>
          <a  style="width: 400px;"></a>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/labManagePlatform/bg3.png'">
      <section class="container">
        <wl-title title='用户价值' :isNeedDesc=false></wl-title>
        <section v-for="(item,index) in page3Data" :key="index" class="box" :class="'box'+index">
          <h3>{{item}}</h3>
        </section>
      </section>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'labManagePlatform',
  data() {
    return {
      bannerData: {
        title: '实验室综合管理平台',
        desc: '对实验室人员、仪器、试剂、危险源、环境等全方位管理\n让实验室管理更便捷、更安全'
      },
      page1Data: [
        { title: '人员的不安全行为', desc: '人员出入无人在岗值守，实验过程中人员操作行为是否规范难以管控' },
        { title: '仪器的不安全状态', desc: '设备仪器运行状态缺少在线化录，出现异常情况无法及时预警难发现' },
        { title: '试剂的不规范使用', desc: '管控化学品未分类存储，使用操作不规范，账物不符难追溯' },
        { title: '环境的不安全因素', desc: '实验室内部操作环境无法实时感知，环境安全存在隐患' },
        { title: '制度的落实不到位', desc: '实验室安全检查执行不到位，效率低，检查审核无法进行完整的业务闭环' }
      ],
      page2Data: [
        { key: 'lmp-1', title: '实验室危化品管理系统', desc: '存储领用规范化', desc1: '危化品全生命周期管理', path: '/product/hazardous' },
        { key: 'lmp-2', title: '仪器预约共享管理系统', desc: '减少管理繁杂工作量', desc1: '仪器资源合理利用', path: '/product/instrument' },
        { key: 'lmp-3', title: '实验室安全教育考试准入系统', desc: '建立严格准入机制', desc1: '提高安全技能和安全意识', path: '/product/approve' },

        { key: 'lmp-5', title: '实验室安全检查管理系统', desc: '提高安全检查效率', desc1: '危化品全生命周期管理', path: '/product/inspect' },
        { key: 'lmp-6', title: '试剂耗材管理系统', desc: '库存精准查询', desc1: '全生命周期管理', path: '/product/reagent' },

      ],
      page3Data: ['要素全面感知\n防范安全隐患', '异常自动预警\n快速应急处置', '流程管理规范\n数据可溯可查', '优化管理方式\n提升管理效率']
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/labManagePlatform/icon.png");
  width: 32px;
  height: 32px;
  display: inline-block;
}
h3 {
  font-size: 20px;
  font-weight: 500;
  color: #262626;
  line-height: 20px;
  padding-bottom: 15px;
  padding-top: 6px;
}
p {
  font-size: 14px;
  color: #8e8e8e;
  line-height: 22px;
}
.page1 {
  height: 838px;
  position: relative;
  .container {
    position: relative;
    height: 100%;
    padding-top: 136px;
  }
  .box {
    width: 266px;
    text-align: left;
    position: absolute;
    h3 {
      font-size: 24px;
      line-height: 24px;
      padding-top: 0;
    }
    p {
      line-height: 24px;
    }
  }
  .box0 {
    top: 267px;
    left: 523px;
  }
  .box1 {
    top: 388px;
    left: 77px;
  }
  .box2 {
    top: 560px;
    left: 52px;
  }
  .box3 {
    top: 388px;
    left: 968px;
  }
  .box4 {
    top: 560px;
    left: 1007px;
  }
}
.page2 {
  background: #fbfbff;
  height: 1185px;
  padding-top: 136px;
  .box {
    width: 400px;
    height: 168px;
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px rgba(176, 198, 225, 0.2);
    border-radius: 14px;
    padding: 43px 45px;
    margin-bottom: 30px;
    border: 1px solid #fff;
    cursor: pointer;
    .sec {
      margin-left: 16px;
    }
    .rightIcon {
      position: absolute;
      width: 66px;
      height: 66px;
      right: 18px;
      bottom: 18px;
    }
    p {
      text-align: left;
    }
    &:hover {
      border: 1px solid #F66A27;
      h3 {
        color: #F66A27;
      }
    }
  }
}
.page3 {
  position: relative;
  height: 690px;
  .container {
    position: relative;
    height: 100%;
    width: 1220px;
    padding-top: 137px;
  }
  .box {
    width: 213px;
    position: absolute;
    h3 {
      padding-top: 24px;
      line-height: 30px;
      padding-bottom: 0;
      font-weight: 400;
      white-space: pre-line;
    }
  }
  .box0 {
    top: 282px;
    left: 109px;
  }
  .box1 {
    top: 282px;
    left: 900px;
  }
  .box2 {
    top: 500px;
    left: 0px;
  }
  .box3 {
    top: 500px;
    left: 1008px;
  }
}
</style>
